import joyrideStyles from "./joyrideStyles";

const tourInitialState = {
  key: new Date(),
  run: true,
  loading: false,
  stepIndex: 0,
  showSkipButton: true,
  showProgress: false,
  continuous: true,
  disableOverlayClose: true,
  styles: joyrideStyles,
};

export default tourInitialState;
